import { ClockCircleOutlined, PhoneOutlined } from '@ant-design/icons';
import { FC } from 'react';
import { NavLink } from 'react-router-dom';

import { useTranslation } from '~shared/lib/i18n';
import { RoutesUrls } from '~shared/lib/router';

import LogoUrl from '~shared/assets/logo.svg';

export interface SiteFooterProps extends Partial<ComponentWithChild> {}

export const SiteFooter: FC<SiteFooterProps> = () => {
  const { t } = useTranslation();

  return (
    <div className="w-full bg-[#F2F2F2]">
      <div className="m-[0_auto] max-w-[1352px] p-[50px_26px_30px] flex flex-col gap-10 sm:p-[24px_16px] sm:gap-6">
        <div className="grid grid-cols-3 gap-10 md:grid-cols-2 sm:grid-cols-1 sm:gap-6">
          <div className="flex flex-col gap-2.5 h-fit">
            <div className="flex gap-3 items-center h-[22px] mb-1.5">
              <img src={LogoUrl} alt="logo" className="h-[28px]" />
              <p className="text-[22px]">{t('appName')}</p>
            </div>
            <p className="text-[12px] text-[#64748B]">{t('site:privacyPolicy')}</p>
            <NavLink
              to={RoutesUrls.requiredDocuments}
              className="text-[12px] text-primary hover:underline"
            >
              {t('site:requiredDocuments')}
            </NavLink>
          </div>

          <div className="flex flex-col gap-4 h-fit">
            <p className="text-[15px] font-semibold uppercase">{t('site:techSupport')}</p>

            <div className="flex flex-col gap-2.5 h-fit">
              <p className="text-[12px] text-[#64748B]">{t('site:techSupportPhone')}</p>
              <a
                href={`tel:${t('site:techSupportPhoneNumber')}`}
                className="flex items-center gap-2 text-[15px] font-medium text-black"
              >
                <PhoneOutlined className="text-primary text-[16px]" />
                {t('site:techSupportPhoneNumber')}
              </a>
            </div>
          </div>

          <div className="flex flex-col gap-4 h-fit">
            <p className="text-[15px] font-semibold uppercase">{t('site:techSupportSchedule')}</p>

            <div className="flex flex-col gap-2.5 h-fit">
              <p className="text-[12px] text-[#64748B]">{t('site:techSupportDays')}</p>
              <p className="flex items-center gap-2 text-[15px] font-medium">
                <ClockCircleOutlined className="text-primary text-[16px]" />
                {t('site:techSupportHours')}
              </p>
            </div>
          </div>
        </div>

        <div className="flex justify-between items-center gap-5 border-t border-stroke pt-5 sm:flex-col sm:items-start sm:gap-2">
          <p className="text-[12px] text-[#64748B]">{t('site:copyright')}</p>
          <p className="text-[12px] text-[#64748B]">
            {t('site:developed')} {t('site:maker')}
          </p>
        </div>
      </div>
    </div>
  );
};
